module.exports = __webpack_public_path__ + "static/img/gaozhonglishi2.c445997a.jpg";